import { render, staticRenderFns } from "./BannerActivateOnlineInStore.vue?vue&type=template&id=4878dc6c&scoped=true&"
import script from "./BannerActivateOnlineInStore.vue?vue&type=script&lang=ts&"
export * from "./BannerActivateOnlineInStore.vue?vue&type=script&lang=ts&"
import style0 from "./BannerActivateOnlineInStore.vue?vue&type=style&index=0&id=4878dc6c&lang=sass&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4878dc6c",
  null
  
)

export default component.exports